(function () {
  const KLAVIYO_FORM_ID_DEFAULT = 'ThzQz9';
  const KLAVIYO_FORM_ID_EN = 'W4z3kj';
  const TRIGGER_SELECTOR = '.footer-col--1';

  function getKlaviyoFormId() {
    const path = window.location.pathname;

    if (path.includes('/en/')) {
      return KLAVIYO_FORM_ID_EN;
    }

    return KLAVIYO_FORM_ID_DEFAULT;
  }

  function openKlaviyoForm() {
    const formId = getKlaviyoFormId();

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);

    console.log('[DB Klaviyo] openForm triggered:', formId);
  }

  function prepareTrigger() {
    const trigger = document.querySelector(TRIGGER_SELECTOR);

    if (!trigger) {
      console.warn('[DB Klaviyo] Trigger non trovato:', TRIGGER_SELECTOR);
      return;
    }

    trigger.classList.add('db-klaviyo-footer-trigger-ready');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');

    console.log('[DB Klaviyo] Trigger trovato e preparato:', trigger);
  }

  document.addEventListener('DOMContentLoaded', function () {
    prepareTrigger();

    setTimeout(prepareTrigger, 1000);
    setTimeout(prepareTrigger, 2500);
  });

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest(TRIGGER_SELECTOR);

    if (!trigger) return;

    event.preventDefault();
    openKlaviyoForm();
  });

  document.addEventListener('keydown', function (event) {
    const trigger = event.target.closest(TRIGGER_SELECTOR);

    if (!trigger) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openKlaviyoForm();
    }
  });
})();